<nb-layout center class="colored-layout-white">
    <nb-layout-column>
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-12 m-auto h-100">
                    <div class="d-flex align-items-center flex-column justify-content-center h-100">
                        <div class="form-container-wrapper">
                            <div class="section-spacer d-flex justify-content-center ">
                                <favrit-logo></favrit-logo>
                            </div>
                            <div class="text-center section-spacer">
                                <h1>Great! We will be in touch soon</h1>
                                <p class="mb-30">
                                    As soon as we have verified the information you provided we will set up your Favrit
                                    account and contact you to help you get started!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nb-layout-column>
</nb-layout>
